<template>
  <div class="container-fluid">
    <el-container>
      <el-header height="15%">
        <el-alert v-if="status===200"
                  title="Заготовленный фильтр успешно удален."
                  type="success"
                  effect="dark">
        </el-alert>
        <div class="row m-4">
          <div class="col-md-6">
            <h4>Популярные подборки</h4>
          </div>
          <div class="col-md-2">
            <el-button type="success" @click="goToPage('popular/create')">Создать подборку</el-button>
          </div>
        </div>
      </el-header>
      <el-main height="80%">
        <el-form aria-label="Поиск" label-width="140px" label-position="left">
          <el-row>
            <el-col :span="12">
              <el-form-item label="Поиск по названию">
                  <el-col :span="14">
                  <el-input v-model="query.q" @change="setQueryReset"></el-input>
                  </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Сортировка">
                  <el-select
                  v-model="query.sort"
                  :width="300"
                  no-data-text="Нет данных"
                  placeholder="Сортировка"
                  @change="setQuery">
                    <el-option
                      v-for="(item, index) in sortConfig"
                      :key="index"
                      :value="item.field"
                      :label="item.title"
                    ></el-option>                          
                  </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-table
            :data="presets"
            style="width: 100%"
            empty-text="Нет данных">
          <el-table-column
              prop="id"
              label="Id"
              width="50">
          </el-table-column>
          <el-table-column
              prop="title"
              label="Название"
              >
          </el-table-column>
          <!-- <el-table-column
              prop="section_id"
              label="Раздел каталога"
              width="100"
             >
             <template slot-scope="scope">
               <p>{{getTitleSectionById(presets[scope.$index].section_id)}}</p>
             </template>
          </el-table-column> -->
          <el-table-column type="expand"
              label="Параметры"
              width="160"
              >
            <template slot-scope="scope">
              <p v-for="item in presets[scope.$index].options" :key="item.id">
                {{item.title}}
                <el-row v-if="item.values">
                  <el-col v-for="(val, index) in item.values" :key="index">
                    {{val}}
                  </el-col>                                   
                </el-row>
                <el-row v-else-if="item.range">
                  <el-col>От: {{item.range.min}}</el-col>
                  <el-col>До: {{item.range.max}}</el-col>
                </el-row>
              </p>
            </template>

          </el-table-column>
          <el-table-column
              label="Цена"
          >
            <template slot-scope="scope">
              <p>{{presets[scope.$index].price.min}} - {{presets[scope.$index].price.max}}</p>
            </template>
          </el-table-column>
            <el-table-column
                    prop="sort"
                    label="Сортировка"
            >
            </el-table-column>

            <el-table-column
                    label="Активность"
            >
                <template slot-scope="scope">
                    <p v-if="!presets[scope.$index].activity">Нет</p>
                    <p v-if="presets[scope.$index].activity">Да</p>
                </template>
            </el-table-column>
            <el-table-column
                    fixed="right"
                    label="Действия"
                    width="400">
                <template slot-scope="scope">
                    <el-button v-if="presets[scope.$index].activity"
                               size="mini"
                               type="primary"
                               plain
                               @click="hideRow(scope.$index)">Скрыть</el-button>
                    <el-button v-if="!presets[scope.$index].activity"
                               size="mini"
                               type="primary"
                               plain
                               @click="restoreRow(scope.$index)">Восстановить</el-button>
                    <el-button size="mini"
                               @click="updateRow(scope.$index)">Изменить</el-button>
                    <el-button size="mini"
                               type="danger"
                               @click.native.prevent="deleteRow(scope.$index)">Удалить</el-button>
                </template>
            </el-table-column>
        </el-table>
      </el-main>
      <el-footer height="5%">
        <el-pagination
            v-if="paginator"
            background
            layout="prev, pager, next"
            :total="paginator.total"
            :current-page.sync="paginator.current_page"
            @current-change="getPage(paginator.current_page)"
            :page-size="paginator.per_page"
            :page-count="paginator.last_page"
            :hide-on-single-page="true"
        >
        </el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
import axios from "axios";
import sortConfig from "../../composable/config/roots-sort.config"
import { SETPRELOADER_STATE } from '@/store/mutation-types'

export default {
  name: "Presets",
  data: function (){
    return{
      sortConfig,
      status:0,
      presets:[],
      paginator: {},
      query:{
          q:'',
          section:'',
          sort: sortConfig[0].field,
          page: 1,
      },
    }
  },
  mounted() {
    this.initParams(this.$route.query);
    this.fetItems(this.getQuery(this.$route.query));
  },

  computed: {
    activeSort() {
      const result = this.sortConfig.find((e) => e.field === this.query.sort)
      return result ? result.options  : undefined
    }
  },

  watch:{
    '$route.query'(v){   
      const query = this.getQuery(v)   
      if (query){              
        this.fetItems(query)
      }
    }
  },

  methods:{
    fetItems: function (query){
      this.$store.commit(SETPRELOADER_STATE, true)
      axios.get('compilation/' + query).then((response)=>{
            this.presets = response.data.data;
            this.paginator = response.data.meta;
        })
        .catch((errors)=>{
          if(errors.response.status === 401){
            this.$router.push('/login');
          }
      })
      .finally(() => this.$store.commit(SETPRELOADER_STATE, false));
    },
    getPage: function(pageNum){
      if (pageNum){
        this.query.page = pageNum
        this.setQuery()
      }
    },
    hideRow: function (index) {
        let id = this.presets[index].id;
        axios.post('compilation/'+id+'/hide').then(()=>{
            this.$notify.success('Подборка скрыта')
            this.fetItems(this.getQuery(this.$route.query));
        }).catch((errors)=>{
            if(errors.response.status === 401){
                this.$router.push('/login');
            }
        });
    },
    restoreRow: function (index) {
      let id = this.presets[index].id;
      axios.post('compilation/'+id+'/restore').then(()=>{
        this.$notify.success('Подборка восстановлена')
        this.fetItems(this.getQuery(this.$route.query));
      }).catch((errors)=>{
        if(errors.response.status === 401){
          this.$router.push('/login');
        }
      });
    },

    deleteRow: function (index) {
      let id = this.presets[index].id;

      axios.delete('/compilation/'+id).then(()=>{
        this.$notify.success('Подборка удалена')
        this.fetItems(this.getQuery(this.$route.query));
      }).catch((errors)=>{
        if(errors?.response?.status === 401){
          this.$router.push('/login');
        }
      });

    },
    updateRow: function (index) {
      let id = this.presets[index].id;
      this.goToPage('/popular/'+id+'/update');
    },
    goToPage: function (path){
      this.$router.push(path);
    },

    setQueryReset(){
      this.query.page = 1
      this.setQuery()
    },
    setQuery(){
      const result = {};
      let isChange = false;
      
      if (this.activeSort) {
        isChange = true;
        result['sort']= {
            by: this.activeSort.by,
            order: this.activeSort.order
        }   
      }
      if (this.query.q) {
        isChange = true;
        result['q']=this.query.q
      }
      if(this.query.page){
        isChange = true
        result['page']=this.query.page
      }

      if (isChange) {
        const q = this.getQuery(result)
        this.$router.push({
          path: 'popular' + q,
        })
      }
    }, 
    getQuery(query) {
      if (Object.keys(query).length > 0){        
        const qs = require('qs');
        return `?${qs.stringify(query)}`
      }
      return ''
    },
    initParams(query){
      if (!query){
        return
      }
      const qs = require('qs');
      const parseQuery= qs.parse(query);
     if (parseQuery.sort?.by && parseQuery.sort?.order) {
        this.query.sort = `${parseQuery.sort.by}.${parseQuery.sort.order}`
      }
      if (parseQuery.q){
        this.query.q = parseQuery.q
      }
      if(query.page){
        this.query.page= parseQuery.page
      }
    }
  }
}
</script>

<style scoped>

</style>